<script lang="ts">
    import cn from 'classnames';

    export let name: string;
    const array = new Array(20).fill(null);
    let clicked: string[] = [];

    const handleClickCell = (row: number, col: number) => () => {
        const key = `${row}-${col}`;
        if (clicked.includes(key)) {
            clicked = clicked.filter(coord => coord !== key);
        } else {
            clicked = clicked.concat(key);
        }
    };

    const handleGeneratePath = (points: string[]) => () => {
        console.log(JSON.stringify(points.map(point => {
            const [row, col] = point.split('-').map(Number);
            return {
                x: col / 2,
                y: row / 2,
            };
        })).replace(/\"/g,""));
    };

</script>

<grid>
    {#each array as row, rowIdx (rowIdx)}
        {#each array as col, colIdx (colIdx)}
            <cell
                class={cn(
                    clicked.includes(`${rowIdx}-${colIdx}`) && 'clicked',
                    colIdx === array.length / 2 - 1 && 'center-right',
                    rowIdx === array.length / 2 - 1 && 'center-bottom',
                )}
                on:click={handleClickCell(rowIdx, colIdx)}
            />
        {/each}
    {/each}
</grid>
<button
    on:click={handleGeneratePath(clicked)}
>
    Generate Path
</button>

<style>
    grid {
        display: grid;
        height: 600px;
        width: 600px;
        grid-template-rows: repeat(20, 30px);
        grid-template-columns: repeat(20, 30px);
        border-left: 1px solid black;
        border-top: 1px solid black;
    }

    cell {
        border-bottom: 1px solid black;
        border-right: 1px solid black;
    }

    cell.center-right {
        border-right: 2px solid black;
    }

    cell.center-bottom {
        border-bottom: 2px solid black;
    }

    cell.clicked {
        background-color: black;
    }
</style>
